<template>
  <div id="app">
    <CustomHeader />
    <div class="page-container">
      <router-view />
    </div>
    <CustomFooter />
  </div>
</template>

<script>
import CustomHeader from "./components/CustomHeader.vue";
import CustomFooter from "./components/CustomFooter.vue";

export default {
  components: {
    CustomHeader,
    CustomFooter,
  },
  created() {
    this.$store.dispatch("system/fetchConfigs");
  },
};
</script>
<style>
@font-face {
  font-family: "SourceHanSansSC";
  src: url("https://img.shineinto.com/static/Bold.woff2"),
    url("https://img.shineinto.com/static/Medium.woff2");
  font-weight: normal;
  font-style: normal;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  max-height: 100vh;
  min-height: 400px;
  overflow: auto;
  margin: 0 auto;
}

.page-container {
  max-width: 1920px;
  margin: 0 auto;
}

.desktop-only #app {
  /* max-width: 1920px; */
}

/* 隐藏 WebKit 浏览器的滚动条 */
*::-webkit-scrollbar {
  display: none;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-align: left;
}

@keyframes customSlideUp {
  from {
    transform: translateY(20px);
  }
  to {
    transform: translateY(0);
  }
}
</style>
